export class DaDataDistricts {
static RUS = {
  nw: [
    { kladr_id: '29' },
    { kladr_id: '35' },
    { kladr_id: '39' },
    { kladr_id: '10' },
    { kladr_id: '11' },
    { kladr_id: '47' },
    { kladr_id: '51' },
    { kladr_id: '29' },
    { kladr_id: '53' },
    { kladr_id: '60' },
    { kladr_id: '78' }
  ],
  fe: [
    { kladr_id: '30' },
    { kladr_id: '14' },
    { kladr_id: '25' },
    { kladr_id: '27' },
    { kladr_id: '28' },
    { kladr_id: '41' },
    { kladr_id: '49' },
    { kladr_id: '65' },
    { kladr_id: '75' },
    { kladr_id: '79' },
    { kladr_id: '87' }
  ],
  volga: [
    { kladr_id: '2' },
    { kladr_id: '12' },
    { kladr_id: '13' },
    { kladr_id: '16' },
    { kladr_id: '18' },
    { kladr_id: '21' },
    { kladr_id: '43' },
    { kladr_id: '52' },
    { kladr_id: '56' },
    { kladr_id: '58' },
    { kladr_id: '59' },
    { kladr_id: '58' },
    { kladr_id: '59' },
    { kladr_id: '58' },
    { kladr_id: '63' },
    { kladr_id: '64' },
    { kladr_id: '73' }
  ],
  nk: [
    { kladr_id: '5' },
    { kladr_id: '6' },
    { kladr_id: '7' },
    { kladr_id: '9' },
    { kladr_id: '15' },
    { kladr_id: '20' },
    { kladr_id: '26' }
  ],
  sib: [
    { kladr_id: '4' },
    { kladr_id: '17' },
    { kladr_id: '19' },
    { kladr_id: '22' },
    { kladr_id: '24' },
    { kladr_id: '38' },
    { kladr_id: '42' },
    { kladr_id: '54' },
    { kladr_id: '55' },
    { kladr_id: '70' }
  ],
  ural: [
    { kladr_id: '45' },
    { kladr_id: '66' },
    { kladr_id: '72' },
    { kladr_id: '74' },
    { kladr_id: '86' },
    { kladr_id: '89' }
  ],
  center: [
    { kladr_id: '31' },
    { kladr_id: '32' },
    { kladr_id: '33' },
    { kladr_id: '36' },
    { kladr_id: '37' },
    { kladr_id: '40' },
    { kladr_id: '44' },
    { kladr_id: '46' },
    { kladr_id: '48' },
    { kladr_id: '50' },
    { kladr_id: '57' },
    { kladr_id: '62' },
    { kladr_id: '67' },
    { kladr_id: '68' },
    { kladr_id: '69' },
    { kladr_id: '71' },
    { kladr_id: '76' },
    { kladr_id: '77' }
  ],
  south: [
    { kladr_id: '1' },
    { kladr_id: '8' },
    { kladr_id: '23' },
    { kladr_id: '30' },
    { kladr_id: '34' },
    { kladr_id: '61' },
    { kladr_id: '91' },
    { kladr_id: '92' }
  ],
  all: []
}
}
